// import { formFactory, FormField, validateUtils } from 'core/form';
import { formFactory, FormField } from 'core/form';
import React from 'react';

export interface SubAcount {
  name?: string;
  commissions?: {
    cents?: number;
    percent?: number;
    credit_card_cents?: number;
    credit_card_percent?: number;
    bank_slip_cents?: number;
    bank_slip_percent?: number;
  };
}
interface Props {
  onSubmit: (formValues: SubAcount) => void;
  actionButtons?: React.ReactNode;
}

const fieldList: FormField[] = [
  { name: 'name', label: 'Nome' },
  { name: 'cents', label: 'Valor em dinheiro', type: 'number' },
  { name: 'percent', label: 'Porcentagem em dinheiro', type: 'number' },
  { name: 'credit_card_cents', label: 'Valor no cartão de crédito', type: 'number' },
  { name: 'credit_card_percent', label: 'Porcentagem no cartão de crédito', type: 'number' },
  { name: 'bank_slip_cents', label: 'Valor no boleto', type: 'number' },
  { name: 'bank_slip_percent', label: 'Porcentagem no boleto', type: 'number' },
];

const validate = (formValues: {}) => {
  // const formFields = fieldList.map(({ name, label }) => ({ name, label }));
  // return validateUtils.notEmpty({
  //   formFields,
  //   formValues,
  // });
  return true;
};

const SUB_ACCOUNT = 'YUGO_SUB_ACCOUNT';
const Form = formFactory<SubAcount>(SUB_ACCOUNT, validate);

class SubAccountFormComponent extends React.Component<Props> {
  onSubmit = (formValues: SubAcount) => {
    this.props.onSubmit(formValues);
  };

  render() {
    return <Form fieldList={fieldList} submitHandler={this.onSubmit} actionButtons={this.props.actionButtons} />;
  }
}

export const SubAccountForm = SubAccountFormComponent;
